module.exports = __webpack_public_path__ + "static/marker-2cb69d4da438355b83b36c2d1f59969e.png";